define('drops/actionSlideshow/actionSlideshow',[
    'jquery',
    'underscore',
    'lq',
    'lq/drop',
    'drops/actionSlideshow/actionSlide'
], function ($, _, lq, Drop, ActionSlide) {

    var ActionSlideshow = function (options) {
        Drop.call(this, $('<div/>'), options);

        this.slides = [];

        this.$element
            .addClass('boxToBorderSize action-slideshow');
        this.$slides = $('<div/>')
            .addClass('action-slideshow-slides')
            .appendTo(this.$element);
    };

    Drop.extend(ActionSlideshow, Drop);

    ActionSlideshow.typeName = 'ActionSlideshow';

    // prevent the page from showing a dialog when a request fails
    ActionSlideshow.prototype.onError = function (e) {
        e.handled = true;
    };

    ActionSlideshow.prototype.preRender = function () {
        this.applyPosition();
    };

    ActionSlideshow.prototype.postRender = function () {
        this.performInitialLoad();
    };

    ActionSlideshow.prototype.performInitialLoad = function () {
        var self = this;
        if (!$.contains(document.body, this.$element[0]))
            return; // removed, stop trying
        this
            .loadSlides()
            .done(function () {
                if (self.slides.length === 0)
                    _.delay(function () { self.performInitialLoad(); }, 5000);
                else
                    self.showSlide(0);
            })
            .fail(function () {
                _.delay(function () { self.performInitialLoad(); }, 5000);
            });
    };

    ActionSlideshow.prototype.loadSlides = function () {
        var deferred = $.Deferred();
        
        var self = this;
        $.ajax({
            url: lq.getTenantUrl('ActionSlideshow/GetSlides'),
            type: 'POST',
            cache: false,
            data: JSON.stringify({
                locals: this.piping.parameters.locals.getAll(),
                globals: this.piping.parameters.globals.getAll(),
                actionId: this.piping.actionId,
                actionSlideshowId: this.data.id
            }),
            dataType: 'json',
            contentType: 'application/json; charset=utf-8'
        })
        .done(function (data) {
            var newSlides = _.map(data.slides, function (slide) {
                return new ActionSlide(slide);
            });

            var promises = _.map(newSlides, function (slide) {
                return slide.init(self.$slides);
            });
            
            // make sure deferred.resolve() is triggered anyway after a certain amount of time
            _.delay(function () {
                if (!deferred)
                    return;

                _.each(newSlides, function (slide) { slide.remove(); });

                deferred.resolve();
                deferred = null;
            }, 15000);

            $.when
                .apply($, promises)
                .done(function () {
                    if (!deferred)
                        return;

                    _.each(self.slides, function(slide) { slide.remove(); });
                    self.slides = newSlides;

                    deferred.resolve();
                    deferred = null;
                });
        })
        .fail(function () {
            deferred.reject();
        });

        return deferred.promise();
    };
    
    ActionSlideshow.prototype.showSlide = function (index) {
        var self = this;
        var slide = this.slides[index];
        slide.show();
        slide.timeout()
            .done(function () {
                var nextIndex = index + 1;

                if (self.slides.length <= nextIndex) {
                    self.loadSlides()
                        .done(function() {
                            slide.hide();

                            if (self.slides.length === 0)
                                _.delay(function () { self.performInitialLoad(); }, 5000);
                            else
                                self.showSlide(0);
                        })
                        .fail(function() {
                            slide.hide();
                            self.showSlide(0);
                        });
                } else {
                    slide.hide();
                    self.showSlide(nextIndex);
                }
        });
    };

    return ActionSlideshow;
});
